const normalizeMethod = (method) =>
  String(method || "GET").trim().toUpperCase();

const methodMatches = (ruleMethods, method) => {
  const normalized = normalizeMethod(method);
  if (!Array.isArray(ruleMethods) || ruleMethods.length === 0) {
    return normalized === "GET";
  }
  return ruleMethods.some((item) => {
    const candidate = normalizeMethod(item);
    return candidate === normalized || candidate === "*" || candidate === "ALL";
  });
};

export const getRules = (data) =>
  data?.access_role?.rules || data?.role?.rules || data?.rules || [];

export const canAccess = (rules, resource, method = "GET") => {
  if (!resource) return false;
  if (!Array.isArray(rules) || rules.length === 0) return false;
  const relevant = rules.filter((rule) => rule?.resource === resource);
  if (relevant.length === 0) return false;
  const deny = relevant.filter(
    (rule) =>
      String(rule?.effect || "").toUpperCase() === "DENY" &&
      methodMatches(rule?.methods, method)
  );
  if (deny.length > 0) return false;
  const allow = relevant.filter(
    (rule) =>
      String(rule?.effect || "").toUpperCase() === "ALLOW" &&
      methodMatches(rule?.methods, method)
  );
  return allow.length > 0;
};
